import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=7927edfe&"
import script from "./Icon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports